import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import { memo } from "react";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";

/* eslint-disable react/prop-types */

const countryOptions = [
  { value: "Việt Nam", label: "Việt Nam" },
  { value: "Lào", label: "Lào" },
  { value: "Trung Quốc", label: "Trung Quốc" },
];

function Fields3({ formData }) {
  const { formField3, values, errors, touched } = formData;
  const {
    countryName,
    airlinesName,
    startDate,
    endDate,
    supplementaryForThe,
    firstTime,
    vehicleName,
    taxAgencyId,
    taxAgencyName,
    agencyId,
    agencyName,
  } =
    formField3;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
      <Grid item xs={6} style={{ paddingTop: 0 }}>
        <DatepickerField
            label={startDate.label}
            name={startDate.name}
            error={errors.startDate && touched.startDate}
            success={values.startDate?.toString().length > 0 && !errors.startDate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
        <DatepickerField
            label={endDate.label}
            name={endDate.name}
            error={errors.endDate && touched.endDate}
            success={values.endDate?.toString().length > 0 && !errors.endDate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={airlinesName.name}
            label={airlinesName.label}
            value={values.airlinesName}
            error={errors.airlinesName && touched.airlinesName}
            success={
              values.airlinesName?.toString().length > 0 && !errors.airlinesName
            }
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={countryOptions}
            type={countryName.type}
            label={countryName.label}
            name={countryName.name}
            value={values.countryName}
            placeholder={countryName.placeholder}
            error={errors.countryName && touched.countryName}
            success={values.countryName.length > 0 && !errors.countryName}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={vehicleName.name}
            label={vehicleName.label}
            value={values.vehicleName}
            error={errors.vehicleName && touched.vehicleName}
            success={
              values.vehicleName?.toString().length > 0 && !errors.vehicleName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agencyName.name}
            label={agencyName.label}
            value={values.agencyName}
            error={errors.agencyName && touched.agencyName}
            success={values.agencyName?.toString().length > 0 && !errors.agencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={agencyId.name}
            label={agencyId.label}
            value={values.agencyId}
            error={errors.agencyId && touched.agencyId}
            success={values.agencyId?.toString().length > 0 && !errors.agencyId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={
              values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyId.name}
            label={taxAgencyId.label}
            value={values.taxAgencyId}
            error={errors.taxAgencyId && touched.taxAgencyId}
            success={
              values.taxAgencyId?.toString().length > 0 && !errors.taxAgencyId
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default memo(Fields3);
